/* @flow */
import React, { useEffect } from 'react';
import { Progress, Spin } from 'antd';
import { useDispatch } from 'react-redux';

type Props = {
  isLoading: boolean,
  percent: number,
  setLoadingPercent: (value: number) => void,
  width?: number,
  children: React$Node,
};

const ProgressLoader = (props: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let timer;

    const percentageLimits = (min, value, max) => {
      return Math.min(Math.max(min, value), max);
    };

    if (props.isLoading) {
      const newPercent = props.percent + 6;
      timer = setTimeout(() => dispatch(props.setLoadingPercent(percentageLimits(0, newPercent, 100))), 1000);
      if (newPercent >= 100) {
        clearTimeout(timer);
        return;
      }
    }

    return () => clearTimeout(timer);
  }, [dispatch, props]);

  const renderProgress = () => {
    return <Progress type="circle" percent={props.percent} width={props.width} />;
  };
  return (
    <Spin indicator={renderProgress()} spinning={props.isLoading}>
      {props.children}
    </Spin>
  );
};

ProgressLoader.defaultProps = {
  width: 80,
};

export default ProgressLoader;
